// ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Disable smooth scrolling temporarily
    const originalScroll = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = "auto";

    window.scrollTo(0, 0); // Jumps instantly

    // Restore original behavior
    document.documentElement.style.scrollBehavior = originalScroll;
  }, [pathname]);

  return null;
}
